import { z } from 'zod'

/**
 * Why the connect screen never opened, carried on `/oauth/error?error=`.
 *
 * These are the codes the API puts on its own error page. Protocol errors
 * that go back to the connecting app (an invalid grant, a denied consent)
 * are a different set and never appear here. An unknown value still has to
 * render as a fixed sentence: the query string is untrusted, and echoing it
 * would show whatever a link was built to say.
 */
export const OAUTH_BROWSER_ERRORS = [
  'invalid_request',
  'invalid_client',
  'invalid_scope',
  'server_error',
] as const

export const oauthBrowserErrorSchema = z.enum(OAUTH_BROWSER_ERRORS)

export type OauthBrowserError = z.infer<typeof oauthBrowserErrorSchema>
